import { Modal, Select, Space, Typography } from "antd";
import { useMutation } from "../../../../../hooks";
import { useEffect, useState } from "react";
import "../css/select-technologies.css";
import { CustomTagRender } from "./custom-tag-render.partial";

export const TechnologiesSelect = ({ value, onChange, options, notificationAPI, refreshOptions }) => {
    const [filteredOptions, setFilteredOptions] = useState(options);
    const [searchValue, setSearchValue] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [pendingValue, setPendingValue] = useState(null);

    const { loading: posting, executeMutation: postTech } = useMutation({
        url: "/catalogtechnology",
        method: "POST",
        onSuccess: async () => {
            notificationAPI.success({
                message: 'La operación se ejecutó correctamente',
                duration: 3,
                className: "custom-notification-bg"
            });
            await refreshOptions();
            setIsModalOpen(false);
        },
        onError: (err) => {
            notificationAPI.error({
                message: "Error al guardar",
                description: err.message,
                className: "custom-notification-bg",
                duration: 3,
            });
            handleCancel();
            setIsModalOpen(false);
        }
    })

    useEffect(() => {
        if (pendingValue) {
            let newValue = value.filter(v => v.label !== pendingValue.label);
            const pendingValueOption = options.find(opt => opt.label === pendingValue.label)
            if (pendingValueOption) {
                newValue = [...newValue, { value: pendingValueOption.value, label: pendingValueOption.label }]
            }
            setPendingValue(null);
            onChange(newValue);
            return;
        }
        if (value && options.length > 0) {
            const syncedValue = value
                .filter(v => options.some(opt => opt.value === v.value))
                .map(v => {
                    const opt = options.find(opt => opt.value === v.value);
                    return opt ? { value: opt.value, label: opt.label } : v;
                });

            onChange(syncedValue);
        }
    }, [options])

    const handleSearch = (input) => {
        setSearchValue(input);
        const filtered = options.filter(opt =>
            opt.label.toLowerCase().includes(input.toLowerCase())
        );
        setFilteredOptions(filtered);
    };

    const handleSelect = (selected) => {
        if (!options.some((opt) => opt.value === selected.value)) {
            setIsModalOpen(true);
            setPendingValue(selected);
        } else {
            setFilteredOptions(options);
            setSearchValue("");

        }
    }

    const handleCancel = () => {
        onChange(value.filter(v => v.value !== pendingValue?.value));
        setIsModalOpen(false);
    }


    return (
        <>
            <Select
                mode="multiple"
                style={{ width: "100%" }}
                placeholder="Ej: JavaScript, Python, React"
                tagRender={CustomTagRender}
                onSearch={handleSearch}
                filterOption={false}
                optionFilterProp="children"
                value={value}
                onChange={onChange}
                onSelect={handleSelect}
                defaultActiveFirstOption
                name="technologies"
                labelInValue
                onDropdownVisibleChange={(open) => {
                    if (open) {
                        setFilteredOptions(options);
                    }
                }}

            >
                {filteredOptions.length > 0 ?

                    filteredOptions.map(opt => (
                        <Select.Option key={opt.value} value={opt.value}>
                            {opt.label}
                        </Select.Option>
                    ))

                    : searchValue.trim() !== "" && (
                        <Select.Option value={searchValue}>
                            {searchValue}
                        </Select.Option>
                    )}
            </Select>
            <Modal
                title={
                    <Typography.Title level={3} style={{ color: "#ffff", margin: 0, padding: 10 }}>
                        Agregar tecnología
                    </Typography.Title>}
                open={isModalOpen}
                onCancel={handleCancel}
                onClose={handleCancel}
                bodyProps={{ style: { padding: 10 } }}
                onOk={() => {
                    if (pendingValue) { postTech({ name: pendingValue.label }) }
                }}
                confirmLoading={posting}
                okButtonProps={{
                    style: {
                        margin: 10,
                        backgroundColor: "var(--color-secondary)",
                        boxShadow: "0 4px 15px rgba(0,0,0,0.15)"
                    }
                }}
            >
                <Space>
                    <Typography.Text>{`No se encontró ${pendingValue ? pendingValue.label : ""} en la lista de tecnologías, ¿Quieres agregarla?`}</Typography.Text>
                </Space>
            </Modal>
        </>
    )
}